__turbopack_context__.v({
  "phoneField": "PhoneInput-module-scss-module__mo9b8a__phoneField",
  "phoneRow": "PhoneInput-module-scss-module__mo9b8a__phoneRow",
  "prefixField": "PhoneInput-module-scss-module__mo9b8a__prefixField",
});
